<div class="tile">
  <div class="header">
    <div class="title">{{ 'SHARED.ITEM_TYPES.FLOWS' | translate }}</div>
  </div>
  <div class="body">
    <div class="buttons">
      <div class="button" (click)="createFlowClicked()" *ngIf="showCreate">
        <div class="icon fa">
          <i class="fa fa-plus-square-o" aria-hidden="true"></i>
        </div>
        <div class="title">
          <div class="line1">{{ 'SHARED.VERBS.CREATE' | translate }}</div>
          &nbsp;
          <div class="line2">{{ 'SHARED.ITEM_TYPES.FLOW' | translate }}</div>
        </div>
      </div>

      <div class="button" (click)="viewFlowsClicked()">
        <div class="icon fa">
          <i class="fa fa-eye" aria-hidden="true"></i>
        </div>
        <div class="title">
          <div class="line1">{{ 'SHARED.VERBS.VIEW' | translate }}</div>
          &nbsp;
          <div class="line2">{{ 'DASHBOARD.FLOWS.FLOWS' | translate }}</div>
        </div>
      </div>

      <div class="button" (click)="viewOpenFlowsClicked()">
        <div class="icon">
          <app-status key="FLOW_02" size="1" width="40" height="40"></app-status>
        </div>
        <div class="title">
          <div class="line1">{{ 'SHARED.VERBS.OPEN' | translate }}</div>
          &nbsp;
          <div class="line2">{{ 'SHARED.ITEM_TYPES.HANDSHAKES' | translate }}</div>
        </div>
      </div>

      <div class="button" (click)="viewDiffFlowsClicked()">
        <div class="icon">
          <app-status key="FLOW_03" size="1" width="40" height="40"></app-status>
        </div>
        <div class="title">
          <div class="line1">{{ 'SHARED.ITEM_TYPES.HANDSHAKE' | translate }}</div>
          &nbsp;
          <div class="line2">{{ 'DASHBOARD.FLOWS.DIFFERENCES' | translate }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
